import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import {
  configureStore as configureStoreRedux,
  Middleware,
  ReducersMapObject,
} from '@reduxjs/toolkit';

import ErrorReporter from 'common/helpers/ErrorReporter';
import commonMiddleware from 'common/middleware';
import usersMiddleware from 'users/middleware';

const configureStore = <S extends any>(
  rootReducer: ReducersMapObject<S>,
  additionalMiddlewares: Middleware<S>[],
) => {
  const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({
      history: createBrowserHistory(),
    });

  const store = configureStoreRedux({
    reducer: { ...rootReducer, router: routerReducer },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([
        routerMiddleware,
        ...commonMiddleware,
        ...usersMiddleware,
        ...additionalMiddlewares,
      ]),
  });

  ErrorReporter.bindStore(store);

  return { store, history: createReduxHistory(store) };
};

export default configureStore;
